import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
var _excluded = ["id", "children", "SearchItemsTransformer", "ResultRenderer"],
  _excluded2 = ["children", "id", "PLS_DONT_USE_skipDefaultStateManagement"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import React, { useEffect, useState, isValidElement } from 'react';
import { useProductStateMachine } from '../../../product-state-machine';
import { ActiveProduct } from '../active-product';
import { EMPTY_SEARCH_ITEMS } from './result-provider-types';
import { ResultRenderer as DefaultResultRenderer } from './result-renderer';
import RegisterAnalytics from './analytics/register-analytics';
import { FasterSearchFirstSection } from './faster-search-first-section';
var DefaultSearchItemsTransformer = function DefaultSearchItemsTransformer(_ref) {
  var preQueryItems = _ref.preQueryItems,
    postQueryItems = _ref.postQueryItems,
    productState = _ref.productState,
    children = _ref.children;
  return /*#__PURE__*/React.createElement(FasterSearchFirstSection, {
    postQueryItems: postQueryItems,
    preQueryItems: preQueryItems
  }, function (_ref2) {
    var fasterSearchItems = _ref2.searchItems;
    var interleavedItems = {
      sections: [].concat(_toConsumableArray(fasterSearchItems.sections), _toConsumableArray(postQueryItems.sections.slice(1))),
      size: postQueryItems.size
    };
    return children({
      preQueryItems: preQueryItems,
      postQueryItems: interleavedItems,
      productState: productState
    });
  });
};
// Visible only for testing
export var ResultProviderStateMachine = function ResultProviderStateMachine(_ref3) {
  var id = _ref3.id,
    children = _ref3.children,
    _ref3$SearchItemsTran = _ref3.SearchItemsTransformer,
    SearchItemsTransformer = _ref3$SearchItemsTran === void 0 ? DefaultSearchItemsTransformer : _ref3$SearchItemsTran,
    _ref3$ResultRenderer = _ref3.ResultRenderer,
    ResultRenderer = _ref3$ResultRenderer === void 0 ? DefaultResultRenderer : _ref3$ResultRenderer,
    rest = _objectWithoutProperties(_ref3, _excluded);
  var _useState = useState(EMPTY_SEARCH_ITEMS),
    _useState2 = _slicedToArray(_useState, 2),
    preQueryItems = _useState2[0],
    setPreQueryItems = _useState2[1];
  var _useState3 = useState(EMPTY_SEARCH_ITEMS),
    _useState4 = _slicedToArray(_useState3, 2),
    postQueryItems = _useState4[0],
    setPostQueryItems = _useState4[1];
  var _useProductStateMachi = useProductStateMachine(_objectSpread({
      id: id,
      setPreQueryItems: setPreQueryItems,
      setPostQueryItems: setPostQueryItems
    }, rest)),
    state = _useProductStateMachi.state,
    onRetryPreQuery = _useProductStateMachi.onRetryPreQuery,
    onRetryPostQuery = _useProductStateMachi.onRetryPostQuery;
  return /*#__PURE__*/React.createElement(ActiveProduct, {
    id: id
  }, /*#__PURE__*/React.createElement(SearchItemsTransformer, {
    preQueryItems: preQueryItems,
    postQueryItems: postQueryItems,
    productState: state
  }, function (args) {
    var transformedPreQueryItems = args.preQueryItems,
      transformedPostQueryItems = args.postQueryItems;
    return /*#__PURE__*/React.createElement(RegisterAnalytics, {
      preQueryItems: transformedPreQueryItems,
      postQueryItems: transformedPostQueryItems,
      productState: state
    }, /*#__PURE__*/React.createElement(ResultRenderer, _extends({}, rest, {
      preQueryItems: transformedPreQueryItems,
      postQueryItems: transformedPostQueryItems,
      productState: state,
      onRetryPreQuery: onRetryPreQuery,
      onRetryPostQuery: onRetryPostQuery
    }), children));
  }));
};
// Visible only for testing
export var ResultProviderLegacy = function ResultProviderLegacy(_ref4) {
  var children = _ref4.children,
    isPrefetchingEnabled = _ref4.isPrefetchingEnabled,
    preQueryItemSupplier = _ref4.preQueryItemSupplier;
  useEffect(function () {
    if (isPrefetchingEnabled) {
      preQueryItemSupplier({
        sectionIds: []
      }); // legacy products like jira and confluence dont use extensible way of rendering results.
    }
  }, [isPrefetchingEnabled, preQueryItemSupplier]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
};

/**
 * This component provides the components with Pre, Post query results and the current state of the product.
 */
export var ResultProvider = function ResultProvider(_ref5) {
  var children = _ref5.children,
    id = _ref5.id,
    PLS_DONT_USE_skipDefaultStateManagement = _ref5.PLS_DONT_USE_skipDefaultStateManagement,
    rest = _objectWithoutProperties(_ref5, _excluded2);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !PLS_DONT_USE_skipDefaultStateManagement ? /*#__PURE__*/React.createElement(ResultProviderStateMachine, _extends({
    id: id
  }, rest), children) : /*#__PURE__*/React.createElement(ResultProviderLegacy, {
    isPrefetchingEnabled: rest.isPrefetchingEnabled,
    preQueryItemSupplier: rest.preQueryItemSupplier
  }, /*#__PURE__*/React.createElement(ActiveProduct, {
    id: id
  }, /*#__PURE__*/isValidElement(children) ? children : null)));
};